define('SageDotCom/PatternAnimations/deviceScroller',[
    "jquery",
    "ScrollMagic",
    "TweenMax",
    "AnimationPlugin"
],
    function (
        $,
        ScrollMagic,
        TweenMax,
        AnimationPlugin
    ) {
        function deviceScroller() { }

        deviceScroller.prototype.initialize = function () {

            // Device animation
            // check if the component for device animation exists
            if ($('.device-animation-vertical-carousel').length) {

                // init controller
                var controller = new ScrollMagic.Controller();

                // add id to background, first and last scene elements
                $('.device-animation-vertical-carousel .score-style-box:first-child').attr('data', 'background-scene');
                $('.device-animation-vertical-carousel .score-style-box:nth-child(2)').attr('data', 'first-scene');
                $('.device-animation-vertical-carousel .score-style-box:last-child').attr('data', 'last-scene');

                // number of slides and slide height
                var slideHeight = $('.device-image-background').height()
                var slideNumber = $('.device-animation-vertical-carousel .score-style-box').not('div[data="background-scene"]').length;

                // phone animation Timeline
                var tl = new TimelineMax();
                tl
                    .to('div[data="background-scene"]', 0, { opacity: 1, top: slideHeight })

                // build background scene
                var backgroundScene = new ScrollMagic.Scene({
                    triggerElement: 'div[data="background-scene"]',
                    duration: slideNumber * slideHeight,
                    triggerHook: 0.3
                })
                    .setPin('div[data="background-scene"]', { pushFollowers: false })
                    .setTween(tl)
                    //.addIndicators({name: 'background scene', indent: 100})
                    .addTo(controller);


                // content scenes
                $('.device-animation-vertical-carousel .score-style-box').not('div[data="background-scene"]').not('div[data="first-scene"]').not('div[data="last-scene"]').each(function () {

                    // content animation Timeline
                    var tl = new TimelineMax();
                    var image = $(this).find('img');
                    var content = $(this).find('.score-left');

                    tl
                        .add('start')
                        .from(content, 1, { opacity: 0, top: 200 })
                        .to(content, 1, { opacity: 0, top: -200 }, 2)
                        .from(image, 1, { opacity: 0 }, 'start')
                        .to(image, 1, { opacity: 0 }, 2);

                    // build content scenes
                    var scenes = new ScrollMagic.Scene({
                        triggerElement: this,
                        duration: slideHeight,
                        triggerHook: 0.3
                    })
                        .setPin(this, { pushFollowers: false })
                        .setTween(tl)
                        //.addIndicators({name: 'content scenes', indent: 220})
                        .addTo(controller);
                });


                var firstImage = $('div[data="first-scene"]').find('img');
                var firstContent = $('div[data="first-scene"]').find('.score-left');

                var tlf = new TimelineMax();

                // last scene animation Timeline
                tlf
                    .add('start')
                    .to(firstContent, 1, { opacity: 0 })
                    .to(firstImage, 1, { opacity: 0 }, 'start')

                // // build last scene
                new ScrollMagic.Scene({
                    triggerElement: 'div[data="first-scene"]',
                    duration: slideHeight,
                    triggerHook: 0.3

                })
                    .setPin('div[data="first-scene"]', { pushFollowers: false })
                    .setTween(tlf)
                    //.addIndicators({name: 'first scene', indent: 420}) // add indicators (requires plugin)
                    .addTo(controller);



                var image = $('div[data="last-scene"]').find('img');
                var content = $('div[data="last-scene"]').find('.score-left');

                // last scene animation Timeline
                tl
                    .add('start')
                    .from(content, 1, { opacity: 0, top: 200 })
                    .from(image, 1, { opacity: 0 }, 'start')

                // build last scene
                new ScrollMagic.Scene({
                    triggerElement: 'div[data="last-scene"]',
                    duration: slideHeight,
                    triggerHook: 0.3

                })
                    .setPin('div[data="last-scene"]', { pushFollowers: false })
                    .setTween(tl)
                    //.addIndicators({name: 'last scene'}) // add indicators (requires plugin)
                    .addTo(controller);
            };


        };
        return new deviceScroller();
    });

